/* eslint-disable react/no-multi-comp */
import { geolocationConnect } from 'geolocation';
import get from 'lodash/get';
import landingPreloader from 'helpers/commonLocationLandingPreloader';
import preload from 'api/data-preload';
import { seoDecorator } from 'api/seo';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import { queryBuilder } from 'components/view-map-search';

import { cottageTownOrders, ordersLC } from './orders';
import AbstractPage, { OBJECTS_PER_PAGE } from './abstract-page';
import blockConfig from '../blocks/config';

@preload((routeProps) => {
  const type = get(routeProps, 'params.landing.params.objectGroup');
  const order = type === 'cottageTowns' ? cottageTownOrders() : ordersLC();

  return (
    landingPreloader(routeProps, blockConfig, {
      dataLimit: OBJECTS_PER_PAGE,
      cacheId: 'newbuildsPageList',
      dataQuery: {
        order: order[0].param
      },
      isQueryParams: {
        unsold: true
      },
      isSearchQuery: () => !!routeProps.location.query.provider,
      queryBuilder: (params, location) =>
        queryBuilder(params, location, order)
    })
  );
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@geolocationConnect({ updateFromLanding: true })
@mstatDecorator(marketStatEvents.historyChange, (props) => {
  const objGroup = get(props, 'params.landing.params.objectGroup');
  switch (objGroup) {
    case 'flats':
      return { entity: 'Каталог ЖК' };
    case 'cottageTowns':
      return { entity: 'Каталог коттеджи' };
    case 'commercial':
      return { entity: 'Каталог коммерческая' };
    default:
      return { entity: 'Страница выборки новостроек' };
  }
})
export default class PageProjectList extends AbstractPage {}
